'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.carousel', {
    url: '/carousel/:lessonId',
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/carousel/carousel.html',
        controller: function ($scope, $stateParams, module) {
          $scope.module = module;
          $scope.current = Math.max(0, _.findIndex(module.lessons, { _id: $stateParams.lessonId }));
        }
      }
    }
  });

});
